/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalProcedureSpeciality from './hospital-procedure-speciality';
import HospitalProcedureSpecialityDetail from './hospital-procedure-speciality-detail';
import HospitalProcedureSpecialityUpdate from './hospital-procedure-speciality-update';
import HospitalProcedureSpecialityDeleteDialog from './hospital-procedure-speciality-delete-dialog';

const HospitalProcedureSpecialityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalProcedureSpeciality />} />
    <Route path="new" element={<HospitalProcedureSpecialityUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalProcedureSpecialityDetail />} />
      <Route path="edit" element={<HospitalProcedureSpecialityUpdate />} />
      <Route path="delete" element={<HospitalProcedureSpecialityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalProcedureSpecialityRoutes;
